export type Axis = "x" | "y" | "z"
